module.exports = __webpack_public_path__ + "img/default-category.9e25d9ca.svg";